var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"speed-box",class:{
    'speed-box__h5': _vm.isH5,
    'speed-box__h5-landscape': _vm.isLandscape,
  }},[_c('span',{staticClass:"speed-btn",on:{"click":_vm.toggleSpeed}},[_vm._v(" "+_vm._s(_vm.speedLabel)+" ")]),(_vm.isShow)?_c('div',{staticClass:"speed-control"},_vm._l((_vm.speedList),function(item){return _c('span',{key:item.value,staticClass:"speed-label",class:{ active: item.value === _vm.speed },on:{"click":function($event){return _vm.changeSpeed(item)}}},[_vm._v(" "+_vm._s(item.label)+" ")])}),0):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }